import styled, { css } from '@xstyled/styled-components';
import { Card } from '~/ui/card/Card';

export const FrontCard = styled(Card)<{ correct?: boolean }>`
  height: 100%;
  overflow: hidden;
  padding-bottom: 20px;

  ${p => {
    if (p.correct === true) {
      return css`
        border: solid 2px;
        border-color: greenDark;
      `;
    } else if (p.correct === false) {
      return css`
        border: solid 2px;
        border-color: redDark;
      `;
    }
  }}
`;
